export default __webpack_public_path__ + "static/media/pipelines-extract.d8d2cda1.svg";